import React from 'react'
import { TagPicker } from 'rsuite'
import { FormikTagPcikerInputs } from './interfaces'

function TagPickerInput<V>({
  formik,
  name,
  inputProps
}: Readonly<FormikTagPcikerInputs<V>>): React.ReactElement {
  const {
    selectOptions = [],
    placeholder,
    isDisabled,
    onTagPickerChange
  } = inputProps

  const fieldValue =
    (formik?.values as Record<string, (number | string)[]>)[name] || []

  const handleChange = (
    value: number[] | string[] | Readonly<number[] | string[]>
  ) => {
    if (onTagPickerChange) {
      onTagPickerChange(value)
    }
  }

  return (
    <TagPicker
      data={selectOptions}
      labelKey="label"
      valueKey="value"
      value={fieldValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={isDisabled}
      block
      data-testid={name}
    />
  )
}

export default TagPickerInput
